import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import _ from 'lodash';
import { MinusIcon, PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import NotificationManager from "react-notifications/lib/NotificationManager";
import { validateInteger } from "../../common/validation/Validators";

// const creditType = [
//     { label: 'Credit', value: '+' },
//     { label: 'Debit', value: '-' },
// ]

// const serviceList = [
//     { label: 'Onboarding + Training Session', value: 150, multiple: false },
//     { label: 'Data Transfer', value: 2, multiple: true },
// ]

const AddTransactionModal = ({
    isModalOpen,
    closeModal,
    org,
    serviceList,
    getServices,
    issueTransaction,
}) => {
    const { watch, setValue, control, handleSubmit, register } = useForm()

    const service = watch('service', serviceList?.[0])

    // const credit = watch("credit")
    const [amount, setAmount] = useState(1)
    const credits = service?.value * amount

    const onSubmit = (data) => {
        data.serviceID = service?.id
        data.amount = amount

        if (service && amount != 0) {
            issueTransaction(data)
        } else {
            NotificationManager.error('Please insure all required fields are filled', 'Error')
        }
    }

    useEffect(() => {
        setAmount(1)
        setValue('service', serviceList?.[0])
    }, [isModalOpen, serviceList])

    useEffect(() => {
        if (!serviceList) {
            getServices()
        }
    }, [serviceList])

    if (!isModalOpen)
        return null

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
                <div className="modal-dialog" style={{ width: "600px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)" }}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b" style={{ paddingBottom: 60 }}>
                            <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Issue Transaction For {org?.businessDetails.name}</h3>
                            </div>
                            <div className="block-content" style={{ padding: 20, paddingTop: 40 }}>

                                <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">Transaction Type</label>
                                        <Controller
                                            as={Select}
                                            control={control}
                                            name="service"
                                            options={serviceList}
                                            value={service}
                                            onChange={(selected) => {
                                                setAmount(1)
                                            }}
                                        />
                                    </div>

                                </div>

                                <div className="col-sm-4" style={{ paddingLeft: 0 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">Quantity</label>
                                        <input
                                            value={amount}
                                            style={{ height: 36, width: '100%' }}
                                            onChange={(e) => {
                                                setAmount(validateInteger(e.target.value))
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="block-content" style={{ padding: 20, paddingTop: 40 }}>
                                {/* {service?.label == "Other" &&
                                <div className="col-sm-6" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">Credit/Debit </label>
                                        <Controller
                                            as={Select}
                                            control={control}
                                            name="credit"
                                            options={creditType}
                                            value={credit}
                                        />
                                    </div>
                                </div>
                            } */}
                                <div className="col-sm-6" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">Credit Amount</label>
                                        <input
                                            className="form-control"
                                            value={credits}
                                            disabled
                                            style={{ height: 36 }}
                                        />
                                        <span style={{ fontSize: 11 }}><strong>Credits Available: </strong>{org?.creditBalance ?? 0}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="block-content" style={{ padding: 20 }}>
                                <div className="col-sm-12" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <label>Reference</label>
                                    <textarea
                                        className="form-control"
                                        type="text"
                                        name="description"
                                        ref={register}
                                        style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                            <button className="btn btn-success pull-right" style={{ marginRight: 25, marginTop: 20, marginBottom: 20 }}>
                                <MinusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                <div style={{ float: "left" }}>Issue Transaction</div>
                            </button>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </form>
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        isModalOpen: state?.company?.billingModal == "Transaction",
        org: state?.payment?.stats,
        serviceList: state?.payment?.serviceList?.map(service => ({
            label: service.name,
            value: service.credits,
            id: service.id
        }))
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(COMPANYACTIONS.setBillingModal()),
    getServices: () => dispatch(PAYMENTACTIONS.getServices()),
    issueTransaction: ({ amount, serviceID, description }) => dispatch(PAYMENTACTIONS.issueTransaction({ amount, serviceID, description }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddTransactionModal)